import { Popover } from 'antd';

export default Popover;



// WEBPACK FOOTER //
// ./src/components/uielements/popover.js